// Autogenerated file
export const syncEntityStatusesEnum = {
    NotSynchronized: "NotSynchronized",
    Success: "Success",
    Failed: "Failed",
};
export const syncEntityStatuses = [
    { label: "Не синхронизировано", value: "NotSynchronized" },
    { label: "Успешно", value: "Success" },
    { label: "Неуспешно", value: "Failed" },
];
